<script lang="ts" setup>
import { computed } from 'vue'

declare const __APP_VERSION__: string

const appVersion = computed(() => __APP_VERSION__)
</script>

<template>
  <footer class="layout-footer p-4 text-center bg-neutral-100">
    <p class="text-xs text-gray-400">v.{{ appVersion }}</p>
    <p class="text-xs text-gray-400">M5 Compound © {{ new Date().getFullYear() }} Massimiliano Marsengo</p>
  </footer>
</template>

<style lang="scss" scoped>
.layout-footer {
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
</style>
